<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-layout justify-center wrap class="white lighten-4 pa-1 caption">
      <v-dialog v-model="popup" max-width="400px" hide-overlay>
        <v-toolbar color="light-green lighten-2" height="100">
          <v-toolbar-title class="body-2 elevation-0"
            >Duplicate - You have already submitted the
            details.</v-toolbar-title
          >
        </v-toolbar>
        <v-card>
          <v-card-actions class="justify-center">
            <v-btn variant="text" @click="goHome()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col cols="12" md="8" sm="8" lg="8">
        <v-card class="elevation-0">
          <div class="text-center mt-3">
            <img src="@/assets/verify.png" width="70" />
            <br />
            <v-alert outlined color="blue" text>
              Verify your membership and reserve your family count for Vaazha
              illai Virudhu Event.

              <v-text-field
                name="primaryemail"
                v-on:keyup="handleInputOnKeyup"
                :rules="emailRules"
                label="E-mail"
                outlined
                dense
                class="mt-4 mx-2"
                id="primaryemail"
                v-model="Json.primaryemail"
                type="primaryemail"
                placeholder=" "
                required
              ></v-text-field>
            </v-alert>
          </div>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="onSignIn"
            action="/dashboards/analytical"
          >
            <v-btn
              color="primary"
              dark
              block
              class="caption mt-1 mx-1"
              submit
              rounded
              @click="checkMembership()"
              >Validate Membership</v-btn
            ><br />
          </v-form>
          <v-form>
            <v-container py-0>
              <v-alert
                v-if="validatedMember"
                dense
                text
                type="success"
              >
                Hooray !! You are a proud member of Charlotte Tamil Sangam.
              </v-alert>
              <div
                v-if="
                  this.Json.message ===
                    'No membership data found for the email provided'
                "
              >
                <v-layout wrap>
                  <v-alert dense text type="error" colored-border color="red">
                    No membership found for the email provided.You could still
                    reserve your family as non members and pay.
                  </v-alert>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-if="validatedNonMember"
                      label="Email"
                      dense
                      outlined
                      :rules="emailRules"
                      v-model="Json.nonMemberEmail"
                      class="body-2 mr-1 purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-if="validatedNonMember"
                      label="First Name"
                      dense
                      outlined
                      :rules="nameRules"
                      v-model="Json.firstname"
                      class="body-2 mr-1 purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-if="validatedNonMember"
                      label="Last Name"
                      dense
                      outlined
                      :rules="nameRules"
                      v-model="Json.lastname"
                      class="body-2 mr-1 purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-select
                      v-if="validatedNonMember"
                      label="Adult Count"
                      class="body-2 mr-1 purple-input"
                      dense
                      outlined
                      v-model="countJson.adultsCount"
                      color="primary"
                      :items="[0, 1, 2]"
                    />
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-select
                      v-if="validatedNonMember"
                      label="Kids Count"
                      class="body-2 mr-1 purple-input"
                      dense
                      v-model="countJson.kidsCount"
                      outlined
                      color="primary"
                      :items="[0, 1, 2, 3]"
                    />
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-select
                      v-if="validatedNonMember"
                      label="Parents/Youth Count"
                      class="body-2 mr-1 purple-input"
                      dense
                      v-model="countJson.parentsCount"
                      outlined
                      color="primary"
                      :items="[0, 1, 2, 3, 4]"
                    />
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field
                      v-if="validatedNonMember"
                      block
                      class="caption mx-1"
                      background-color="lime lighten-5"
                      dense
                      prefix="$"
                      label="Pay"
                      outlined
                      v-model="nonMemberAmount"
                      readonly
                    ></v-text-field
                    ><br />
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      v-if="validatedNonMember"
                      block
                      class="caption mx-1"
                      color="info"
                      submit
                      @click="nonMemberSubmitCount()"
                      >Reserve Count</v-btn
                    ><br />
                  </v-flex>
                </v-layout>
              </div>

              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    v-if="validatedMember"
                    label="First Name"
                    dense
                    v-model="Json.firstname"
                    class="body-2 mr-1 purple-input"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-if="validatedMember"
                    label="Last Name"
                    dense
                    v-model="Json.lastname"
                    class="body-2 mr-1 purple-input"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-if="validatedMember"
                    label="Year"
                    dense
                    v-model="Json.year"
                    class="body-2 mr-1 purple-input"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-if="validatedMember"
                    label="Membership"
                    class="body-2 mr-1 purple-input"
                    dense
                    v-model="Json.membershipcategory"
                    disabled
                    color="primary"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-select
                    v-if="validatedMember"
                    label="Adult Count"
                    class="body-2 mr-1 purple-input"
                    dense
                    outlined
                    v-model="countJson.adultsCount"
                    color="primary"
                    :items="[0, 1, 2]"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-select
                    v-if="validatedMember"
                    label="Kids Count"
                    class="body-2 mr-1 purple-input"
                    dense
                    v-model="countJson.kidsCount"
                    outlined
                    color="primary"
                    :items="[0, 1, 2, 3]"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-select
                    v-if="validatedMember"
                    label="Parents/Youth Count"
                    class="body-2 mr-1 purple-input"
                    dense
                    v-model="countJson.parentsCount"
                    outlined
                    color="primary"
                    :items="[0, 1, 2, 3, 4]"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-if="validatedMember"
                    block
                    class="caption mx-1"
                    background-color="lime lighten-5"
                    dense
                    prefix="$"
                    label="Pay"
                    outlined
                    v-model="memberAmount"
                    readonly
                  ></v-text-field
                  ><br />
                </v-flex>
                <v-flex xs12 md3>
                  <v-btn
                   v-if="validatedMember"
                    block
                    class="caption mx-1"
                    color="info"
                    submit
                    @click="submitCount()"
                    >Reserve Count</v-btn
                  ><br />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="12" md="1" sm="1" lg="1"> </v-col>
      <v-col cols="12" md="3" sm="3" lg="3">
        <br /><br />
        <v-expansion-panels
          v-model="panel"
          :disabled="disabled"
          multiple
          focusable
        >
          <v-expansion-panel>
            <v-expansion-panel-header>Tech Issues</v-expansion-panel-header>
            <v-expansion-panel-content
              ><br />
              If u are member and still dont see your data using primary email
              id or any technical issues contact whatsapp @ +1 8484671136 or
              email
              <a
                href="mailto: snarasimman@gmail.com?subject=CLTTS- Membership Issue"
                >Narasimman Sridhar</a
              >
              <br />
            </v-expansion-panel-content>
            <v-expansion-panel-header
              >For CLTTS Members</v-expansion-panel-header
            >
            <v-expansion-panel-content
              ><br />
              Kids under 5 – Free <br />
              Per One Adult (food) - <b>15 $ </b><br />
              Per Kid (5-13 age) – <b>10 $ </b><br />
            </v-expansion-panel-content>
            <v-expansion-panel-header
              >For Non -Members</v-expansion-panel-header
            >
            <v-expansion-panel-content
              ><br />
              Kids under 5 – Free <br />
              Per adult - <b>20 $ </b><br />
              Per kid 5-13 age – <b>13 $ </b><br />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import ReportServices from "@/services/ReportServices";
export default {
  name: "FullLogin",
  data() {
    return {
      panel: [0, 0],
      readonly: false,
      popup: false,
      nameRules: [(v) => !!v || "This Field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      form: false,
      valid: true,
      text: "",
      Json: {
        primaryemail: "",
      },
      countJson: {
        kidsCount: 0,
        adultsCount: 0,
        parentsCount: 0,
        primaryemail: "",
        firstname: "",
        lastname: "",
        membershipcategory: "",
        paymentstatus: "",
        year: "",
        nonMemberEmail: "",
        memberAmount: 0,
        nonMemberAmount: 0,
      },
      primaryemail: "",
      show3: false,
    };
  },
  computed: {
    formIsValid() {
      return this.primaryemail !== "";
    },
    validatedMember () {
      return (
        this.Json.membershipcategory === "Family" ||
        this.Json.membershipcategory === "Paarivallal" ||
        this.Json.membershipcategory === "Single"
      )
    },
    validatedNonMember () {
      return (
        this.Json.membershipcategory !== "Family" ||
        this.Json.membershipcategory !== "Paarivallal" ||
        this.Json.membershipcategory !== "Single"
      )
    },
    nonMemberAmount() {
      var totalRows = 0;
      totalRows =
        this.countJson.adultsCount * 20 +
        this.countJson.kidsCount * 13 +
        this.countJson.parentsCount * 20;
      return totalRows;
    },
    memberAmount() {
      var tRows = 0;
      tRows =
        this.countJson.adultsCount * 15 +
        this.countJson.kidsCount * 10 +
        this.countJson.parentsCount * 15;
      return tRows;
    },
  },
  methods: {
    handleInputOnKeyup() {
      this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim();
    },
    goHome() {
      this.$router.replace("/Events");
    },
    nonMember() {
      this.$router.push({ path: "/NonMemberPayments", replace: true });
    },
    async checkMembership() {
      this.primaryemail = this.Json.primaryemail;
      this.refresh();
    },
    async nonMemberSubmitCount() {
      this.countJson.primaryemail = this.Json.nonMemberEmail;
      this.countJson.firstname = this.Json.firstname;
      this.countJson.lastname = this.Json.lastname;
      this.countJson.membershipcategory = "NonMember";
      this.countJson.year = "2023";
      this.countJson.checkinstatus = "Y";
      this.countJson.event = "CTV2023";
      this.countJson.amount = this.nonMemberAmount;
      this.responseData = await ReportServices.reserveCountForEvent(
        this.countJson
      );
      if (this.responseData.data === "Already Submitted") {
        this.popup = true;
      } else this.$router.push({ path: "/NonMemberPayments", replace: true });
    },
    async submitCount() {
      this.countJson.primaryemail = this.Json.primaryemail;
      this.countJson.firstname = this.Json.firstname;
      this.countJson.lastname = this.Json.lastname;
      this.countJson.membershipcategory = this.Json.membershipcategory;
      this.countJson.year = this.Json.year;
      this.countJson.paymentstatus = this.Json.paymentstatus;
      this.countJson.checkinstatus = "Y";
      this.countJson.event = "CTV2023";
      this.countJson.memberid = this.Json._id;
      this.countJson.amount = this.memberAmount;
      this.responseData = await ReportServices.reserveCountForEvent(
        this.countJson
      );
      if (this.responseData.data === "Already Submitted") {
        this.popup = true;
      } else this.$router.push({ path: "/MemberPayments", replace: true });
    },
    async refresh() {
      this.profileData = await ReportServices.validateMembership(
        this.primaryemail
      );
      this.Json = this.profileData.data;
      this.nonMemberEmail = this.Json.primaryemail;
    },
  },
  async mounted() {
    this.refresh();
  },
};
</script>